import { FC } from 'react';
import { TextKey } from '@mews-commander/enums';
import { NumberInputField } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { FormFields } from '../../../schema';

export const OrderingField: FC = () => (
    <NumberInputField label={lt(TextKey.Ordering)} name={FormFields.Ordering} required />
);
